import styled, { keyframes } from 'styled-components';

export const minHeight = 40;
const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;
const onEnter = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Wrapper = styled('section')`
  position: relative;
  width: 100%;
  z-index: 0;
  animation: ${onEnter} 0.5s ${cubicBezier};
  z-index: 0;
`;

export const Chart = styled('svg')`
  position: absolute;
  bottom: 0;
  animation: ${onEnter} 0.5s ${cubicBezier};
`;

export const ChartDefinitions = styled('svg')`
  display: block;
  width: 0;
  height: 0;
`;

export const Status = styled('div')<{ height?: number }>`
  animation: ${onEnter} 0.5s ${cubicBezier};
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme }) => theme.color.whiteRGBA(0.3)};
  height: ${({ height = minHeight }) => height}px;
  background: ${({ theme }) => theme.color.whiteRGBA(0.05)};
  padding: ${({ theme }) => theme.x1spacePx / 2}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
